import { render, staticRenderFns } from "./DeviceAllocationList.vue?vue&type=template&id=fba186ca&scoped=true"
import script from "./DeviceAllocationList.vue?vue&type=script&lang=js"
export * from "./DeviceAllocationList.vue?vue&type=script&lang=js"
import style0 from "./DeviceAllocationList.vue?vue&type=style&index=0&id=fba186ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba186ca",
  null
  
)

export default component.exports